import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { getToken } from "./auth";
import icon_err from "@/components/icon/icon_err.vue";

// formData请求方式
// let fromdata = new FormData();
// fromdata.append('key',value)
// const reg =  await this.$http.post('/upload',fromdata)

// 请求头设置
export const setRequestHeader = config => {
  config['Content-Type'] = 'application/json;charset=utf-8';
  return config;
};

// 设置身份
export const setAuth = config => {
  const isToken = (config.headers || {}).isToken === false;
  if (getToken() && !isToken) {
    config.headers.Authorization = 'Bearer' + ' ' + getToken();
  }
  return config;
};

// 错误处理
export const handleNetworkError = data => {
  let errMessage = data;
  if (errMessage) {
    MessageBox(errMessage, 'error');
  }
};

// 权限数据处理
// 将请求的权限转化成需要的数据格式
export const handleLimits = (menu, parent) => {
  let tree = [];
  if (parent) {
    for (var i = 0; i < menu.length; i++) {
      if (menu[i].pid === parent) {
        if (handleLimits(menu, menu[i].id).length == 0) {
          let node = {
            id: menu[i].id,
            name: menu[i].name,
            path: menu[i].path,
            icon: menu[i].icon
          };
          tree.push(node);
        } else {
          let node = {
            id: menu[i].id,
            name: menu[i].name,
            path: menu[i].path,
            icon: menu[i].icon,
            children: handleLimits(menu, menu[i].id)
          };
          tree.push(node);
        }
      }
    }
  } else {
    menu.forEach(item => {
      if (item.pid == 0) {
        if (handleLimits(menu, item.id).length == 0) {
          let node = {
            id: item.id,
            name: item.name,
            path: item.path,
            icon: item.icon
          };
          tree.push(node);
        } else {
          let node = {
            id: item.id,
            name: item.name,
            path: item.path,
            icon: item.icon,
            children: handleLimits(menu, item.id)
          };
          tree.push(node);
        }
      }
    });
  }
  return tree;
};